import { React } from "react";
import { Box } from "@mui/material";
import WalletTile from "./WalletsTile";
import { useTranslation } from "react-i18next";

function Accounts({ wallets }) {
	const filterWallets = (type) => {
		return wallets.filter((wallet) => wallet.type === type);
	};
	const { t } = useTranslation();

	const boxStyles = {
		borderRadius: "20px",
		flex: 1,
		minWidth: 500,
		display: "flex",
		flexDirection: "column",
		gap: 2,
	};
	return (
		<Box sx={boxStyles}>
			<WalletTile
				title={"💵 " + t("cashWallets")}
				type="cash"
				wallets={filterWallets("cash")}
			/>
			<WalletTile
				title={"🏠 " + t("assets")}
				type="asset"
				wallets={filterWallets("asset")}
			/>
			<WalletTile
				title={"🧾 " + t("liabilities")}
				type="liability"
				wallets={filterWallets("liability")}
			/>
		</Box>
	);
}

export default Accounts;
